function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { isEmpty } from 'lodash';
import { BaseCard, BaseCardBody, BaseCardHeader } from '@unite-us/ui';
import { ServiceProviderListItem } from "./index";
var TOGGLE_TEXT = {
  select: 'Select All',
  deselect: 'Deselect All'
};
var providerIsAlreadySelected = function providerIsAlreadySelected(providerId, providerIds) {
  return providerIds.includes(providerId);
};
var getSelectedText = function getSelectedText(selectedProvidersCount, providersCount, text) {
  if (selectedProvidersCount === 0) {
    return TOGGLE_TEXT.select;
  } else if (selectedProvidersCount === providersCount) {
    return TOGGLE_TEXT.deselect;
  }
  return text;
};
var ServiceProvidersList = /*#__PURE__*/function (_PureComponent) {
  function ServiceProvidersList(props) {
    var _this;
    _classCallCheck(this, ServiceProvidersList);
    _this = _callSuper(this, ServiceProvidersList, [props]);
    _this.addSelectedProvider = _this.addSelectedProvider.bind(_this);
    _this.toggleSelectedGroups = _this.toggleSelectedGroups.bind(_this);
    _this.addProviders = _this.addProviders.bind(_this);
    _this.state = {
      selectedProviderIds: [],
      toggleText: TOGGLE_TEXT.select
    };
    return _this;
  }
  _inherits(ServiceProvidersList, _PureComponent);
  return _createClass(ServiceProvidersList, [{
    key: "addSelectedProvider",
    value: function addSelectedProvider(provider) {
      var _this2 = this;
      var selectedProviderIds = providerIsAlreadySelected(provider.id, this.state.selectedProviderIds) ? this.state.selectedProviderIds.filter(function (pId) {
        return pId !== provider.id;
      }) : [].concat(_toConsumableArray(this.state.selectedProviderIds), [provider.id]);
      var toggleText = getSelectedText(selectedProviderIds.length, this.props.providers.length, this.state.toggleText);
      this.setState({
        selectedProviderIds: selectedProviderIds,
        toggleText: toggleText
      }, function () {
        _this2.addProviders();
      });
    }
  }, {
    key: "addProviders",
    value: function addProviders() {
      this.props.addToSelectedProviders(this.props.header, this.state.selectedProviderIds);
    }
  }, {
    key: "toggleSelectedGroups",
    value: function toggleSelectedGroups() {
      var _this3 = this;
      var toggleText = this.state.toggleText === TOGGLE_TEXT.select ? TOGGLE_TEXT.deselect : TOGGLE_TEXT.select;
      var selectedProviderIds = this.state.toggleText === TOGGLE_TEXT.select ? this.props.providers.map(function (p) {
        return p.id;
      }) : [];
      this.setState({
        toggleText: toggleText,
        selectedProviderIds: selectedProviderIds
      }, function () {
        _this3.addProviders();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        providers = _this$props.providers,
        header = _this$props.header;
      var selectedProviderIds = this.state.selectedProviderIds;
      var emptyProviders = /*#__PURE__*/React.createElement("div", {
        className: "empty-providers"
      }, "No Organizations Found");
      return /*#__PURE__*/React.createElement(BaseCard, {
        className: "service-provider-list"
      }, /*#__PURE__*/React.createElement(BaseCardHeader, {
        title: header
      }), /*#__PURE__*/React.createElement(BaseCardBody, {
        withPadding: true,
        className: "service-provider-list__body"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "service-provider-list__list list-unstyled"
      }, isEmpty(providers) ? emptyProviders : providers.map(function () {
        var provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return /*#__PURE__*/React.createElement("li", {
          className: "service-provider-list__list-item",
          key: provider.id
        }, /*#__PURE__*/React.createElement(ServiceProviderListItem, {
          provider: provider,
          isSelected: providerIsAlreadySelected(provider.id, selectedProviderIds)
        }));
      }))));
    }
  }]);
}(PureComponent);
ServiceProvidersList.propTypes = {
  addToSelectedProviders: PropTypes.func.isRequired,
  providers: PropTypes.array,
  header: PropTypes.string.isRequired
};
ServiceProvidersList.defaultProps = {
  providers: []
};
export default ServiceProvidersList;